import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {EyeBallIcon} from "../../common/icons";
import workspaceZoom from "../../sqft/components/canvas/core/workspaceZoom";
import {
  isQuoteByQTCatNameEqualToCurrentQuote,
  loadQuoteByQtCatName
} from "../../sqft/helpers/sqftQuotesHelper";

const SqftFeaturesPopupFeatureEyeball = (props) => {
  const {editButtonColor, sqftFeature} = props;

  const eyeballButtonClick = () => {
    //console.log("sqftFeature", sqftFeature);
    openShapeRoom(sqftFeature).then(() => {
      zoomToSqftFeature(sqftFeature);
    });
  };

  const openShapeRoom = async (sqftFeature) => {
    if (sqftFeature.qtCatName) {
      if (!isQuoteByQTCatNameEqualToCurrentQuote(sqftFeature.qtCatName)) {
        loadQuoteByQtCatName(sqftFeature.qtCatName).then();
      }
    } else {
      console.log("sqftFeature qtCatName not set, shape room cannot be opened", sqftFeature.qtCatName);
    }
  };

  const zoomToSqftFeature = (sqftFeature) => {
    if (Array.isArray(sqftFeature.sqftIds) && sqftFeature.sqftIds.length > 0) {
      workspaceZoom.zoomToFeatures(sqftFeature);
    } else {
      workspaceZoom.zoomToFeature(sqftFeature);
    }
  };

  return (
    <button className="sqft-popup__feature-eyeball" onClick={eyeballButtonClick} >
      <EyeBallIcon color={editButtonColor}/>
    </button>
  )
};

SqftFeaturesPopupFeatureEyeball.propTypes = {
  editButtonColor: PropTypes.string.isRequired,
  sqftFeature: PropTypes.object.isRequired,
}

const mapStateToProps = (store) => {
  return {
    activeTheme: store.serverState.activeTheme,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupFeatureEyeball)
